"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWidgetComponent = void 0;
const react_1 = require("react");
const ahooks_1 = require("ahooks");
const initialize_widget_1 = require("../../initialize_widget");
function useWidgetComponent(codeUrl, widgetPackageId) {
    const componentRef = (0, react_1.useRef)();
    // if need to load the widget package.
    const validate = Boolean(codeUrl && widgetPackageId);
    const [loading, setLoading] = (0, react_1.useState)(validate);
    const [count, { inc: refreshVersion }] = (0, ahooks_1.useCounter)(0);
    const [error, setError] = (0, react_1.useState)();
    const preCount = (0, react_1.useRef)(count);
    const preCodeUrl = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        if (!validate) {
            componentRef.current = undefined;
            return;
        }
        (0, initialize_widget_1.loadWidget)(codeUrl, widgetPackageId, 
        // when version is refreshed or incoming codeUrl changes, the widget code package is reloaded
        count > preCount.current || (Boolean(preCodeUrl.current) && preCodeUrl.current !== codeUrl)).then(component => {
            componentRef.current = component;
            setLoading(false);
            setError(undefined);
        }).catch(error => {
            setError(error);
        }).then(() => {
            preCount.current = count;
            preCodeUrl.current = codeUrl;
        });
    }, [codeUrl, count, setLoading, widgetPackageId, validate]);
    const refresh = (0, react_1.useCallback)(() => {
        componentRef.current = undefined;
        setLoading(true);
        refreshVersion();
    }, [refreshVersion]);
    return (0, react_1.useMemo)(() => [componentRef.current, refresh, loading, error], [error, loading, refresh]);
}
exports.useWidgetComponent = useWidgetComponent;
